import { Messages } from 'lib/intl/messages';

export const messages: Messages = {
  RELEASE_INVOICES: {
    en: 'Release <strong>{count}</strong> {count, plural, one{invoice} other{invoices}}',
    de: '<strong>{count}</strong> {count, plural, one{Rechnung} other{Rechnungen}} freigeben',
  },
  RELEASE_ALL: {
    en: 'Release all',
    de: '<strong>Alles</strong> freigeben',
  },
  RELEASE_TYPE: {
    en: 'Type',
    de: 'Typ',
  },
  RELEASE_DATE: {
    en: 'Date',
    de: 'Datum',
  },
  RELEASE_TOTAL: {
    en: 'Total',
    de: 'Gesamt',
  },
};
